export default __webpack_public_path__ + "static/2473-2a688595bacb744dda7dd76b9a749b79.gif";